import Swiper, { Navigation, Pagination, Autoplay, EffectFade} from 'swiper'

Swiper.use([Navigation, Pagination, Autoplay, EffectFade]);

var alu = document.querySelector('.alu .swiper-container');

// ALU
if (alu) {
    var state = document.querySelector('.alu-navigation__item--mode');
    var nbSlides = document.querySelectorAll('.alu .swiper-container .swiper-slide').length;
    var dataSlideAuto = document.querySelector('.alu .swiper-container').getAttribute('data-slide_auto');
    var dataSlideSpeed = document.querySelector('.alu .swiper-container').getAttribute('data-slide_speed');
    dataSlideSpeed = dataSlideSpeed + '000';


    var aluConfig = {
        slidesPerView: 1,
        centeredSlides: true,
        speed: 700,
        loop: true,
        autoHeight: true,

        keyboard: {
            enabled: true,
        },

        mousewheel: {
            forceToAxis: true,
            releaseOnEdges: true,
        },

        navigation: {
            prevEl: '.alu-navigation__item--prev',
            nextEl: '.alu-navigation__item--next',
        },
    };


    if (window.innerWidth > 640) {
        if (dataSlideAuto === '1') {
            aluConfig.autoplay = {
                delay: dataSlideSpeed,
                disableOnInteraction: false,
            }

            state.addEventListener('click', function () {
                if (aluSwiper.autoplay.running) {
                    aluSwiper.autoplay.stop();

                    state.classList.remove('alu-navigation__item--pause')
                    state.classList.add('alu-navigation__item--play');
                }

                else {
                    aluSwiper.autoplay.start();

                    state.classList.remove('alu-navigation__item--play')
                    state.classList.add('alu-navigation__item--pause');
                }
            });
        }
    }

    if (nbSlides > 1) {
        var aluSwiper = new Swiper('.alu .swiper-container', aluConfig);
    }
}